module.exports = __webpack_public_path__ + "img/zip.0443c8eb.svg";